<script lang="ts">
  import RetailerFulfillmentMethodsStore from "@retailer/svelte/stores/RetailerFulfillmentMethodsStore";

  // components
  import FulfillmentMethodOptions from "@retailer/svelte/Shared/FulfillmentMethodOptions.svelte";

  // types
  import type { Product } from "@shared/types/ProductLine";

  export let distributor = null;
  export let open = false;
  export let skus = [];
  export let products: Product[] = [];
  export let forProductLine: boolean = true;

  const distributorId = distributor?.id || distributor?.distributor_id;

  $: fulfillmentMethod = $RetailerFulfillmentMethodsStore[distributorId] || null;
  $: selectedStockSiteId = fulfillmentMethod?.warehouse?.location_code;
</script>

{#if distributorId}
  <div class="craft">
    <FulfillmentMethodOptions
      bind:open
      {distributor}
      {skus}
      {products}
      {selectedStockSiteId}
      {forProductLine}
    />
  </div>
{/if}
